<script>
import api from "@/axios";
import { SimpleBar } from "simplebar-vue3";
import { authComputed } from "@/state/helpers";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  data() {
    return {
      empresaAtu: '01',
      filiais: [
        {
          id: 1,
          codigo: "01",
          nome: "Testes",
        },
      ],
      emprlist: null,
      podeAltEmpresa: true,

     loadingData: true,
     base64logow: null,
     blobUrlWhite: null,
     blobUrlBlack: null,
     empreConf: null,
     totalNotificacoes: 3,
     notificacoesData: [],
     userLogged: {},
     textoPesquisa: '',
     lang: "pt_BR",
      text: null,
      flag: null,
      value: null,
       languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "pt_BR",
          title: "Português",
        },
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ]
    };
  },
  components: { SimpleBar },
  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.empreConf = JSON.parse(localStorage.getItem('emprconf'))

    // console.log('this.userLogged_00')
    // console.log(this.userLogged)

    const selecEmpr = localStorage.getItem('empratu')
    if (selecEmpr){
      this.empresaAtu = localStorage.getItem('empratu')
    }

    if (!this.emprlist) {
      api.get(`${getBaseUrl()}api/emprlist`).then((res) => {
        // console.log('then axios atualizando emprlist')
        // console.log(res.data)
        this.emprlist = res.data
      })
    } else {
      // console.log('existe emprlist')
      // console.log(this.emprlist)
    }

    // console.log('emprConf_created')
    // console.log(this.empreConf)

    if (!this.empreConf) {
      api.get(`${getBaseUrl()}api/emprconf`).then((res) => {
        this.empreConf = {
          'cnpj': res.data[0]['cnpj'],
          'nome': res.data[0]['fantasia'],
          'layout': res.data[0]['layout'],
          'width': res.data[0]['width'],
          'sidebar': res.data[0]['sidebar'],
          'logow': res.data[0]['logow'],
          'logob': res.data[0]['logob'],
          'regtrib': res.data[0]['regtrib'],
        }

        localStorage.setItem('emprconf', JSON.stringify(this.empreConf))

        this.carregarLogo(this.empreConf.logow)
      }).catch((err) => {
        console.log('erro emprconf')
        console.log(err)
        this.loadingData = false
      })
    } else {
      this.carregarLogo(this.empreConf.logow)
    }


  },
  mounted() {

    // console.log('mounted_nav_bar')
    // console.log(this.$route.path)

    if (this.$route.path.includes('editar') || this.$route.path.includes('detalhes')) {
      this.podeAltEmpresa = false
    }

    //textPesquisa
    //if (this.$route.path !== '/suporte/pesquisa' && !this.$route.path.includes('saidaeditarnova')){
    if (this.$route.path !== '/suporte/pesquisa'){
      // this.$nextTick(() => this.$refs.textPesquisa.focus())
    }


    // console.log('mounted navBar_0')

    // FUNCAO TEMPORARIA PARA CAPTURA DE NOTIFICAÇÕES
    // setInterval(() => {
    //   axios.get(`${getBaseUrl()}api/notifics`).then((res) => {
    //     console.log('then axios norifics_0')
    //     console.log(res.data[0].length)
    //     this.notificacoesData = res.data[0]
    //     this.totalNotificacoes = res.data[0].length
    //   });
    // }, 3000)




  },
  methods: {
    carregarLogo(pathLogo) {
      if (!pathLogo) {
        this.loadingData = false
        return
      }

      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: pathLogo }
      }).then((res) => {
        // res.data e um Blob: o tamanho fica em .size, nao em .length
        if (res.data && res.data.size > 0) {
          this.blobUrlWhite = URL.createObjectURL(res.data)
        }
        this.loadingData = false
      }).catch((err) => {
        console.log('erro logo')
        console.log(err)
        this.loadingData = false
      })
    },
    mudouEmpresa() {
      console.log('mudouEmpresa')

      api.post(`${getBaseUrl()}api/mudouempr`, {
        empresaAtu: this.empresaAtu
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        localStorage.setItem('empratu', res.data['codigo'])

        location.reload()

        // this.updating = false
        //
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Informações salvas com sucesso!",
        //   showConfirmButton: false,
        //   timer: 1500
        // })
        //
        // if (this.idData === 0){
        //   this.idData = res.data[0].id
        //   this.$router.replace('/tabpreco/editar/' + this.idData)
        // }

      })

    },


    logout(){
      localStorage.removeItem('user')
      localStorage.removeItem('emprconf')
      localStorage.removeItem('emprlist')
      localStorage.removeItem('empratu')
      localStorage.removeItem('preferencias')

      this.$router.push('/login')
    },
    handleSubmitPesquisa() {
      console.log('handleSubmitPesquisa')
      console.log(this.textoPesquisa)

      switch (this.textoPesquisa){
        case 'da1':
          this.$router.push({path: "/", force: true })
          break
        case 'da2':
          this.$router.push({path: "/dashboard/atendimento", force: true })
          break
        case 'da3':
          this.$router.push({path: "/dashboard/analitico", force: true })
          break
        case 'da4':
          this.$router.push({path: "/dashboard/supervisao", force: true })
          break

        case 'orc':
          this.$router.push({path: "/orcamentos/list", force: true })
          break
        case 'orn':
          this.$router.push({path: "/orcamento/editar/0", force: true })
          break
        case 'ped':
          this.$router.push({path: "/pedidos/list", force: true })
          break
        case 'cli':
          this.$router.push({path: "/clientes/list", force: true })
          break
        case 'cln':
          this.$router.push({path: "/cliente/editar/0", force: true })
          break
        case 'vis':
          this.$router.push({path: "/visitas/list", force: true })
          break
        case 'loj':
          this.$router.push({path: "/loja/produtos", force: true })
          break
        case 'cal':
          this.$router.push({path: "/calendario", force: true })
          break
        case 'pro':
          this.$router.push({path: "/produtos/list", force: true })
          break
        case 'prn':
          this.$router.push({path: "/produto/editar/0", force: true })
          break
        case 'com':
          this.$router.push({path: "/compras/list", force: true })
          break
        case 'mon':
          this.$router.push({path: "/compras/monitora", force: true })
          break
        case 'con':
          this.$router.push({path: "/condicoes/list", force: true })
          break
        case 'for':
          this.$router.push({path: "/formas/list", force: true })
          break
        case 'tpo':
          this.$router.push({path: "/tiposopera/list", force: true })
          break
        case 'rep':
          this.$router.push({path: "/repres/list", force: true })
          break
        case 'fin':
          this.$router.push({path: "/financeiros/list", force: true })
          break
        case 'desp':
          this.$router.push({path: "/financeiros/despesas", force: true })
          break
        case 'rece':
          this.$router.push({path: "/financeiros/receitas", force: true })
          break
        case 'proj':
          this.$router.push({path: "/projetos/list", force: true })
          break
        case 'usu':
          this.$router.push({path: "/usuarios/list", force: true })
          break
        case 'usn':
          this.$router.push({path: "/usuario/editar/0", force: true })
          break
        case 'ate':
          this.$router.push({path: "/atendimentos/list", force: true })
          break
        case 'aut':
          this.$router.push({path: "/atendimentos/chat", force: true })
          break
        case 'not':
          this.$router.push({path: "/notificacoes/list", force: true })
          break
        case 'arq':
          this.$router.push({path: "/arquivos", force: true })
          break
        case 'sup':
          this.$router.push({path: "/suporte/material", force: true })
          break

        default:
          this.$router.push(
              {
                name: "SuptPesquisa",
                params: { pesquisa: this.textoPesquisa },
                force: true
              }
          )
      }



    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },


  },
  computed: {
    ...authComputed,
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">

          <b-spinner v-if="loadingData"
                     type="border"
                     class="m-6 mx-2 mt-4"
                     variant="light"
                     role="status">
          </b-spinner>
          <div id="divlogowhite">

          </div>

          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg" >
                <img :src="base64logow" alt height="17" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light" v-if="userLogged && userLogged.tipo === 'admin'">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="22" />
            </span>
            <span class="logo-lg" >
              <img :src="blobUrlWhite" alt height="60" v-if="blobUrlWhite"/>
              <img src="@/assets/images/logo_econo_pro.png" alt height="60" v-else-if="!loadingData"/>
            </span>
          </router-link>

          <router-link to="/dashboard/fretes" class="logo logo-light" v-else>
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="22" />
            </span>
            <span class="logo-lg" >
              <img :src="blobUrlWhite" alt height="60" v-if="blobUrlWhite"/>
              <img src="@/assets/images/logo_econo_pro.png" alt height="60" v-else-if="!loadingData"/>
            </span>
          </router-link>


        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <!-- App Search-->
        <form class="app-search d-none d-lg-block" @submit.prevent="handleSubmitPesquisa" v-if="$route.path !== '/suporte/pesquisa' && userLogged && userLogged.tipo === 'admin'">
          <div class="position-relative">
            <input
              id="inputPesquisa"
              ref='textPesquisa'
              v-model="textoPesquisa"
              type="text"
              class="form-control"
              placeholder="Pesquisar / atalhos...."
            />
            <span class="bx bx-search-alt"></span>
          </div>
        </form>

        <b-dropdown
          v-if="userLogged && userLogged.tipo === 'admin'"
          variant="black"
          class="dropdown-mega d-none d-lg-block ms-2"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
        >
          <template v-slot:button-content>
            Todos os Recursos
            <i class="mdi mdi-chevron-down"></i>
          </template>

          <div class="row">
            <div class="col-sm-8">
              <div class="row">



                <div class="col-md-4" v-if="userLogged && userLogged.tipo === 'admin'">
                  <h5 class="font-size-14 mt-0">
                    Dashboards
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <router-link to="/">
                        {{ $t("navbar.dropdown.megamenu.dashboards.list.default") }}
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/dashboard/atendimento">
                        {{ $t("navbar.dropdown.megamenu.dashboards.list.atendimento") }}
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/dashboard/analitico">
                        {{ $t("navbar.dropdown.megamenu.dashboards.list.analitico") }}
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/dashboard/supervisao">
                        {{ $t("navbar.dropdown.megamenu.dashboards.list.supervisao") }}
                      </router-link>
                    </li>
                  </ul>
                </div>


                <div class="col-md-4" v-else-if="userLogged && userLogged.tipo === 'repres'">
                  <h5 class="font-size-14 mt-0">
                    Dashboard Representante
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <router-link to="/">
                        {{ $t("navbar.dropdown.megamenu.dashboards.list.default") }}
                      </router-link>
                    </li>
                  </ul>
                </div>

                <div class="col-md-4">
                  <h5 class="font-size-14 mt-0">
                    Comercial
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <router-link to="/orcamentos/list">
                        Orçamentos
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/pedidos/list">
                        Pedidos
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/clientes/list">
                        Clientes
                      </router-link>
                    </li>
                    <li v-if="userLogged && userLogged.tipo === 'admin'">
                      <router-link to="/loja/produtos">
                        Loja
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/calendario">
                        Calendário
                      </router-link>
                    </li>


                  </ul>
                </div>

                <div class="col-md-4" v-if="userLogged.tipo === 'admin'">
                  <h5 class="font-size-14 mt-0">
                    Administrativo
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <router-link to="/produtos/list">
                        Produtos
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/condicoes/list">
                        Condições de Pagamento
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/formas/list">
                        Formas de Pagamento
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/tiposopera/list">
                        Tipos de Operação
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/repres/list">
                        Representantes
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/usuarios/list">
                        Usuários
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <div class="col-sm-6">
                  <h5 class="font-size-14 mt-0">
                    Auxiliar
                  </h5>
                  <ul class="list-unstyled megamenu-list">
                    <li>
                      <router-link to="/notificacoes/list">
                        Notificações
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/arquivos">
                        Arquivos
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/suporte/material">
                        Material de Apoio
                      </router-link>
                    </li>



                  </ul>
                </div>

                <div class="col-sm-5">
                  <div>
                    <img
                      src="@/assets/images/megamenu-img.png"
                      alt
                      class="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-dropdown>
      </div>

      <div class="d-flex">
        <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify"></i>
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  id="inputRecipients"
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar..."
                  aria-label="Recipient's username"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="submit">
                    <i class="mdi mdi-magnify"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown>

        <select id="selectFilial" v-model="empresaAtu"
                class="lang-dropdown border-0 text-black-50 "
                v-if="emprlist && podeAltEmpresa" @change="mudouEmpresa">
          <option v-for="filial in emprlist" :key="filial.id" :value="filial.codigo">
            {{ filial.fantasia }}
          </option>
        </select>

<!--        <select id="selectLang" v-model="$i18n.locale" class="lang-dropdown border-0">-->
<!--          <option v-for="(locale, i) in languages" :key="`locale-${i}`" :value="locale.language">-->
<!--            {{ locale.title }}-->
<!--          </option>-->
<!--        </select>-->

        <b-dropdown
          v-if="userLogged && userLogged.tipo === 'admin'"
          class="d-none d-lg-inline-block noti-icon"
          menu-class="dropdown-menu-lg dropdown-menu-end"
          right
          toggle-class="header-item"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-customize"></i>
          </template>

          <div class="px-lg-2">
            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="@/assets/images/brands/github.png" alt="Github" />
                  <span>Filial 001</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img
                    src="@/assets/images/brands/bitbucket.png"
                    alt="bitbucket"
                  />
                  <span>Filial 002</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img
                    src="@/assets/images/brands/dribbble.png"
                    alt="dribbble"
                  />
                  <span>Filial 003</span>
                </a>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="@/assets/images/brands/dropbox.png" alt="dropbox" />
                  <span>Filial 004</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img
                    src="@/assets/images/brands/mail_chimp.png"
                    alt="mail_chimp"
                  />
                  <span>Filial 005</span>
                </a>
              </div>
              <div class="col">
                <a class="dropdown-icon-item" href="javascript: void(0);">
                  <img src="@/assets/images/brands/slack.png" alt="slack" />
                  <span>Filial 006</span>
                </a>
              </div>
            </div>
          </div>
        </b-dropdown>


        <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge bg-danger rounded-pill">{{ totalNotificacoes }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="#" class="small">{{
                  $t("navbar.dropdown.notification.subtext")
                }}</a>
              </div>
            </div>
          </div>

          <SimpleBar style="max-height: 230px">

            <a
                v-for="notific in notificacoesData" :key="notific.id"
                href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span
                      class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ notific.descr1 }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ notific.descr2 }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ notific.descr3 }}
                    </p>
                  </div>
                </div>
              </div>
            </a>


            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.order.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.order.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>

            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <img
                  src="@/assets/images/users/avatar-3.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.james.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.james.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>

            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="bx bx-badge-check"></i>
                  </span>
                </div>
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.item.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.item.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>

            <a href="javascript: void(0);" class="text-reset notification-item">
              <div class="d-flex">
                <img
                  src="@/assets/images/users/avatar-4.jpg"
                  class="me-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="flex-grow-1">
                  <h6 class="mt-0 mb-1">
                    {{ $t("navbar.dropdown.notification.salena.title") }}
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      {{ $t("navbar.dropdown.notification.salena.text") }}
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>

          </SimpleBar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
              type="button"
              class="btn header-item noti-icon"
              @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>

          <img
              class="rounded-circle header-profile-user btn header-item noti-icon"
              src="@/assets/images/users/avatar-14.png"
              alt="Header Avatar"/>
        </div>


        <b-dropdown
            right
            variant="black"
            toggle-class="header-item"
            menu-class="dropdown-menu-end">
          <template v-slot:button-content>


            <span class="d-none d-xl-inline-block ms-1">
              <!--  BOLINHA COM TEXTO NO LUGAR DE FOTO            -->
              <!--  <span class="avatar-title rounded-circle">{{userLogged.nome.substring(0, 5)}}</span>  -->
              <div >
                {{ userLogged.nome }}
                <br>
                {{ userLogged.tipo }}
              </div>
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>



          <b-dropdown-item>
            <router-link :to="'/usuario/perfil/' + userLogged.id" v-slot="{ navigate }" custom>
              <span @click="navigate" @keypress.enter="navigate">
                <i class="bx bx-user font-size-16 align-middle me-1"></i>
                Meu Perfil
              </span>
            </router-link>
          </b-dropdown-item>

<!--          <b-dropdown-item>-->
<!--            <router-link to="/orcamentos/list" v-slot="{ navigate }" custom>-->
<!--              <span @click="navigate" @keypress.enter="navigate">-->
<!--&lt;!&ndash;                <i class="bx bx-wallet font-size-16 align-middle me-1"></i>&ndash;&gt;-->
<!--                <span class="badge bg-warning align-middle me-1">181</span>-->
<!--                Orçamentos-->
<!--              </span>-->

<!--            </router-link>-->
<!--          </b-dropdown-item>-->


          <!--          <b-dropdown-item class="d-block" href="javascript: void(0);">-->
          <!--            <i class="bx bx-wrench font-size-16 align-middle me-1"></i>-->
          <!--            Configurações-->
          <!--          </b-dropdown-item>-->


          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item class="dropdown-item text-danger" @click="logout">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            <span class="text-danger">Logout</span>
          </b-dropdown-item>
        </b-dropdown>

        <div class="dropdown d-inline-block"
             v-if="userLogged && userLogged.tipo === 'admin'">
          <button
            type="button"
            class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar"
          >
            <i class="bx bx-cog bx-spin toggle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </header>
</template>
